export const getPercentageChange = (value: number, averageValue: number) => {
  if (averageValue === 0) {
    return null;
  }
  const change = value - averageValue;
  const percentageChange = Math.round((change / averageValue) * 100);
  return percentageChange;
};
